import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { StaticContext, DesktopScreen, MobileScreen } from '@sm/webassets';
import { getClientEnvironmentDetails } from '@sm/utils';

const MediaCarousel = ({ media }) => {
  const [current, setCurrent] = useState(0);
  const currentMedia = media[current];
  const { userAgent } = useContext(StaticContext);
  const { isDesktop } = getClientEnvironmentDetails(userAgent);

  if (!currentMedia) {
    return null;
  }

  return (
    <>
      <MobileScreen defaultMatches={!isDesktop}>
        <div className="sm-app-directory-app-details__media-container sm-app-directory-app-details__media-container--mobile">
          {media.map(m => (
            <Choose>
              <When condition={m.type === 'youtube'}>
                <div
                  key={m.url}
                  className="sm-app-directory-app-details__media-video-container sm-app-directory-app-details__media-video-container--mobile"
                >
                  <iframe
                    className="sm-app-directory-app-details__media-video-container-frame"
                    data-testid="MediaCarousel__SelectedVideo"
                    allowFullScreen
                    src={m.url}
                    title={m.altText}
                  />
                </div>
              </When>
              <Otherwise>
                <div
                  key={m.url}
                  className="sm-app-directory-app-details__media-image-container sm-app-directory-app-details__media-image-container--mobile"
                >
                  <img
                    alt={m.altText}
                    data-testid="MediaCarousel__SelectedImage"
                    className="sm-app-directory-app-details__media-image-container-image"
                    src={m.url}
                  />
                </div>
              </Otherwise>
            </Choose>
          ))}
        </div>
      </MobileScreen>
      <DesktopScreen defaultMatches={isDesktop}>
        <>
          <div className="sm-app-directory-app-details__media-container">
            <Choose>
              <When condition={currentMedia.type === 'youtube'}>
                <div className="sm-app-directory-app-details__media-video-container">
                  <iframe
                    className="sm-app-directory-app-details__media-video-container-frame"
                    data-testid="MediaCarousel__SelectedVideo"
                    allowFullScreen
                    src={currentMedia.url}
                    title={currentMedia.altText}
                  />
                </div>
              </When>
              <Otherwise>
                <div className="sm-app-directory-app-details__media-image-container">
                  <img
                    alt={currentMedia.altText}
                    data-testid="MediaCarousel__SelectedImage"
                    className="sm-app-directory-app-details__media-image-container-image"
                    src={currentMedia.url}
                  />
                </div>
              </Otherwise>
            </Choose>
          </div>
          <div
            className="sm-app-directory-app-details__media-thumbnails wds-flex"
            data-testid="MediaCarousel__Thumbnails"
          >
            {media.map((m, mediaIdx) => (
              <div
                key={m.url}
                className={`sm-app-directory-app-details__media-thumbnails-preview ${
                  mediaIdx === current ? 'sm-app-directory-app-details__media-thumbnails-preview--active' : ''
                }`}
                onKeyUp={e => {
                  if (e.key === 'Enter') {
                    setCurrent(mediaIdx);
                  }
                }}
                role="button"
                onClick={() => {
                  setCurrent(mediaIdx);
                }}
                tabIndex={0}
              >
                <Choose>
                  <When condition={m.type === 'youtube'}>
                    <iframe
                      data-testid="MediaCarousel__Thumbnail"
                      className="sm-app-directory-app-details__media-thumbnails-frame"
                      allowFullScreen
                      src={m.url}
                      title={m.altText}
                    />
                  </When>
                  <Otherwise>
                    <img
                      data-testid="MediaCarousel__Thumbnail"
                      alt={m.altText}
                      className="sm-app-directory-app-details__media-thumbnails-image"
                      src={m.url}
                    />
                  </Otherwise>
                </Choose>
              </div>
            ))}
          </div>
        </>
      </DesktopScreen>
    </>
  );
};
MediaCarousel.propTypes = {
  media: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['youtube', 'image']).isRequired,
      url: PropTypes.string.isRequired,
      altText: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default MediaCarousel;
